module.exports = __webpack_public_path__ + "static/media/SDFSA_5-682w.ca4f8306.webp";